import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState, type EntityRef } from "@client/types";
import Component, { type MapProps } from "./component";

const makeMapStateToProps = () => {
  const textSelector = getSettingValueSelector(TargetSelector.Entity, "text");

  return (state: AppState, props: EntityRef): MapProps => {
    return {
      ...props,
      text: textSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
